import React from 'react';
import { AppBar, Toolbar, Typography } from '@mui/material';

const PartnerTopNav = () => {
  return (
    <AppBar
      sx={{
        background: 'white',        
      }}
    >
      <Toolbar>
        <Typography variant="body2">Partner Top Nav</Typography>
      </Toolbar>
    </AppBar>
  );
};

export default PartnerTopNav;
